export enum BrandTypeEnum {
  PLAY = 'Play',
  VIRGIN = 'Virgin'
}
